import { render, staticRenderFns } from "./TuiguangDetails.vue?vue&type=template&id=9bd7273a&scoped=true"
import script from "./TuiguangDetails.vue?vue&type=script&lang=js"
export * from "./TuiguangDetails.vue?vue&type=script&lang=js"
import style0 from "./TuiguangDetails.vue?vue&type=style&index=0&id=9bd7273a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd7273a",
  null
  
)

export default component.exports